@if (filtersForm()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    title="{{ title() }}"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
  ></vectronic-filter-header>

  <div
    class="utc-filter filter-body"
    [hidden]="!isFilterHidden()"
    [formGroup]="filtersForm()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
  >
    <label class="filter-label">Latitude[deg]</label>
    <div class="filter-container">
      <mat-form-field class="input-form" appearance="outline">
        <mat-label>Min</mat-label>
        <input
          class="filter-input"
          [min]="lowestPossibleLatitudeValue"
          [max]="highestPossibleLatitudeValue"
          maxlength="10"
          matInput
          #minLatitude
          pattern="-?(0|([1-9]\d{0,2}))(\.\d{0,5})?"
          [formControlName]="'minLatitude'"
          (input)="
            setValidCoordinatesFieldValue(
              'minLatitude',
              lowestPossibleLatitudeValue,
              highestPossibleLatitudeValue
            )
          "
        />
        <mat-error>Illegal</mat-error>
      </mat-form-field>
      <mat-form-field class="input-form" appearance="outline">
        <mat-label>Max</mat-label>
        <input
          class="filter-input"
          [min]="lowestPossibleLatitudeValue"
          [max]="highestPossibleLatitudeValue"
          [errorStateMatcher]="latErrorStateMatcher"
          maxlength="10"
          matInput
          #maxLatitude
          pattern="-?(0|([1-9]\d{0,2}))(\.\d{0,5})?"
          [formControlName]="'maxLatitude'"
          (input)="
            setValidCoordinatesFieldValue(
              'maxLatitude',
              lowestPossibleLatitudeValue,
              highestPossibleLatitudeValue
            )
          "
        />
        @if (filtersForm().hasError('latMinGreaterThenMax')) {
          <mat-error>Too low</mat-error>
        }
        @if (filtersForm().hasError('latMaxGeneralError')) {
          <mat-error>Illegal</mat-error>
        }
      </mat-form-field>
    </div>
    <label class="filter-label">Longitude[deg]</label>
    <div class="filter-container">
      <mat-form-field class="input-form" appearance="outline">
        <mat-label>Min</mat-label>
        <input
          class="filter-input"
          [min]="lowestPossibleLongitudeValue"
          [max]="highestPossibleLongitudeValue"
          maxlength="11"
          matInput
          #minLongitude
          pattern="-?(0|([1-9]\d{0,3}))(\.\d{0,5})?"
          [formControlName]="'minLongitude'"
          (input)="
            setValidCoordinatesFieldValue(
              'minLongitude',
              lowestPossibleLongitudeValue,
              highestPossibleLongitudeValue
            )
          "
        />
        <mat-error>Illegal</mat-error>
      </mat-form-field>
      <mat-form-field class="input-form" appearance="outline">
        <mat-label>Max</mat-label>
        <input
          class="filter-input"
          [min]="lowestPossibleLongitudeValue"
          [max]="highestPossibleLongitudeValue"
          [errorStateMatcher]="longErrorStateMatcher"
          maxlength="11"
          matInput
          #maxLongitude
          pattern="-?(0|([1-9]\d{0,3}))(\.\d{0,5})?"
          [formControlName]="'maxLongitude'"
          (input)="
            setValidCoordinatesFieldValue(
              'maxLongitude',
              lowestPossibleLongitudeValue,
              highestPossibleLongitudeValue
            )
          "
        />
        @if (filtersForm().hasError('longMinGreaterThenMax')) {
          <mat-error>Too low</mat-error>
        }
        @if (filtersForm().hasError('longMaxGeneralError')) {
          <mat-error>Illegal</mat-error>
        }
      </mat-form-field>
    </div>
    @if (this.pageName() !== 'VirtualFence') {
      <label class="filter-label">Altitude[m]</label>
      <div class="filter-container">
        <mat-form-field class="input-form" appearance="outline">
          <mat-label>Min</mat-label>
          <input
            class="filter-input"
            [min]="lowestPossibleAltitudeValue"
            [max]="highestPossibleAltitudeValue"
            maxlength="7"
            matInput
            #minAltitude
            pattern="-?(0|([1-9]\d{0,5}))"
            [formControlName]="'minAltitude'"
            (input)="
              setValidCoordinatesFieldValue(
                'minAltitude',
                lowestPossibleAltitudeValue,
                highestPossibleAltitudeValue
              )
            "
          />
          <mat-error>Illegal</mat-error>
        </mat-form-field>
        <mat-form-field class="input-form" appearance="outline">
          <mat-label>Max</mat-label>
          <input
            class="filter-input"
            [min]="lowestPossibleAltitudeValue"
            [max]="highestPossibleAltitudeValue"
            [errorStateMatcher]="altErrorStateMatcher"
            maxlength="7"
            matInput
            #maxAltitude
            pattern="-?(0|([1-9]\d{0,5}))"
            [formControlName]="'maxAltitude'"
            (input)="
              setValidCoordinatesFieldValue(
                'maxAltitude',
                lowestPossibleAltitudeValue,
                highestPossibleAltitudeValue
              )
            "
          />
          @if (filtersForm().hasError('altMinGreaterThenMax')) {
            <mat-error>Too low</mat-error>
          }
          @if (filtersForm().hasError('altMaxGeneralError')) {
            <mat-error>Illegal</mat-error>
          }
        </mat-form-field>
      </div>
    }
  </div>
}
